import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Nav from "../Nav/Nav";
import Footer from "../Footer/Footer";
import DescriptionTechnologies from "./Detail/DescriptionTechnologies";
import Loaded from "./Detail/Loaded";
import * as images from "../../assets/exportImages";

const ProjectDetails = (props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [project, setProject] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => setLoading(), 1500);
    t("project", { returnObjects: true }).map((item) => {
      if (item.route === props.match.params.id) {
        return setProject(item);
      }
    }, []);
  }, [t("projectDescription.technologies")]);

  const {
    description,
    github,
    live,
    name,
    technologies,
    functions,
    functionality,
    next,
    previous,
    img,
  } = project;

  console.log("project :>> ", project);
  console.log("images[project.img] :>> ", images[project.img]);
  const Project = (
    <header className="context">
      <Nav show={true} />
      <div className="loaded">
        <div className="loaded__name">{name}</div>
        <div className="loaded__description">{description}</div>
        <figure>
          <img className="loaded__img" src={images[img]} alt={name} />
        </figure>
        <div className="loaded__button">
          {github && (
            <a href={github}>
              <button className="loaded__button__left ">GitHub</button>
            </a>
          )}
          {live && (
            <a href={live}>
              <button className="loaded__button__right">Demo</button>
            </a>
          )}
        </div>
        {functions && (
          <div className="loaded__functionality">
            <div className="loaded__functions">{functions}</div>
            <ul>
              {functionality &&
                functionality.map((item) => {
                  return <li key={item.id}>{item.id}</li>;
                })}
            </ul>
          </div>
        )}
        <DescriptionTechnologies
          technologies={technologies}
          next={next}
          previous={previous}
        />
      </div>
      <Footer />
    </header>
  );

  const loaded = <Loaded />;
  return <section className="details">{loading ? loaded : Project}</section>;
};

export default ProjectDetails;
